import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

const BASE = `${BACKEND_URL}/transferts/cameroun-chine`;

export type CmrChinaPayoutStatus = "PENDING_MANUAL_PAYOUT" | "IN_PROGRESS" | "COMPLETED" | "FAILED" | "CANCELED";

export type CmrChinaOperationType = "INDIVIDUAL" | "SUPPLIER";

export type CmrChinaAttachmentKind = "payment_qr" | "contact_doc" | "invoice";

export interface CmrChinaTransfer {
  transfert: {
    id: string;
    user_id: string;
    sending_amount: number;
    fee: number;
    total_amount: number;
    conversion_rate: number;
    receiving_amount: number;
    description: string | null;
    status: string;
    txt_reference: string;
    created_at: string;
  } | null;
  details: {
    id: string;
    sender_phone: string;
    recipient_name: string;
    recipient_address: string;
    recipient_phone: string | null;
    recipient_email: string | null;
    operation_type: CmrChinaOperationType | null;
    is_company: boolean | null;
    company_name: string | null;
    representative_name: string | null;
    province: string | null;
    city: string | null;
    street: string | null;
    unit: string | null;
    invoice_number: string | null;
    invoice_date: string | null;
    payment_method: string | null;
    payment_account: string | null;
    has_payment_qr: boolean;
    has_contact_doc: boolean;
    has_invoice: boolean;
    status: CmrChinaPayoutStatus | null;
    payout_note: string | null;
    payout_processed_at: string | null;
    created_at: string;
  };
  sender?: { id: string; name: string | null; email: string | null; phone: string | null };
}

export interface CmrChinaListParams {
  status?: CmrChinaPayoutStatus;
  operation_type?: CmrChinaOperationType;
  search?: string;
  skip?: number;
  limit?: number;
}

const ACTION_PATH: Partial<Record<CmrChinaPayoutStatus, string>> = {
  IN_PROGRESS: "in-progress",
  COMPLETED: "complete",
  FAILED: "fail",
  CANCELED: "cancel",
};

const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const cmrChinaTransferService = {
  async list(token: string, params: CmrChinaListParams): Promise<{ total: number; items: CmrChinaTransfer[] }> {
    const response = await axios.get(`${BASE}/admin/list`, { ...auth(token), params });
    return response.data?.data ?? { total: 0, items: [] };
  },

  async updateStatus(token: string, extensionId: string, status: CmrChinaPayoutStatus, note?: string) {
    const path = ACTION_PATH[status];
    if (!path) throw new Error(`Statut non modifiable : ${status}`);
    const response = await axios.post(`${BASE}/${extensionId}/${path}`, note ? { note } : {}, auth(token));
    return response.data?.data;
  },

  /** Ouvre une pièce jointe (protégée par le token admin) dans un nouvel onglet. */
  async openAttachment(token: string, extensionId: string, kind: CmrChinaAttachmentKind) {
    const response = await axios.get(`${BASE}/${extensionId}/attachments/${kind}`, {
      ...auth(token),
      responseType: "blob",
    });
    const url = URL.createObjectURL(response.data);
    window.open(url, "_blank", "noopener");
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  },
};
